import { render, staticRenderFns } from "./ReporteComision.vue?vue&type=template&id=46856dfb"
import script from "./ReporteComision.vue?vue&type=script&lang=js"
export * from "./ReporteComision.vue?vue&type=script&lang=js"
import style0 from "./ReporteComision.vue?vue&type=style&index=0&id=46856dfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports